import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

import LinkedMembersTable from './LinkedMembersTable';

const LinkedMembersContent = ({ members }) => {
	const hasItems = Boolean(members.length);

	return hasItems ? (
		<LinkedMembersTable rows={members} />
	) : (
		<Stack spacing={2} sx={{ alignItems: 'center' }}>
			<PersonSearchIcon sx={{ width: '3em', height: '3em' }} />
			<Typography>No linked members yet</Typography>
		</Stack>
	);
};

export default LinkedMembersContent;
